export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11436.4c99d47d.jpg";